import { useAuth } from '@/lib'
import { roleEnum } from '@jobilla/nexus-sdk'

export const useIsAdmin = () => {
	const { role } = useAuth()
	return role === roleEnum.admin
}
